import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, LinkData, TextInput } from '../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TeaserBigConverter extends CmsConverterService<TeaserBigData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_title_text?.value
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      switchImageAndText: formData.st_switch_image_and_text?.value ?? false,
      text: formData.st_text ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      label: formData.st_label ?? defaultTextInput,
      promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? true,
      link: formData?.st_input_link ?? defaultLinkData,
    }
  }
}

export const TEASER_BIG_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBigData>>('TeaserBigConverter')

export interface TeaserBigData extends ConvertedComponentData {
  image: Image;
  label: TextInput;
  switchImageAndText: boolean;
  promotionTracking: boolean;
  headline: TextInput;
  text: TextInput;
  link: LinkData;
}
